
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Button from '../../../components/base/Button';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentWord, setCurrentWord] = useState(0);
  
  const words = ['GÜÇLÜ', 'GÜVENİLİR', 'KALİTELİ', 'DAYANIKLI'];

  useEffect(() => {
    setIsVisible(true);
    
    const interval = setInterval(() => {
      setCurrentWord((prev) => (prev + 1) % words.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.8), rgba(15, 23, 42, 0.8)), url('https://readdy.ai/api/search-image?query=Industrial%20metal%20workshop%20with%20steel%20bolts%20nuts%20screws%20and%20fasteners%20arranged%20on%20dark%20metallic%20surface%2C%20professional%20lighting%20highlighting%20the%20precision%20engineering%20and%20quality%20craftsmanship%2C%20modern%20industrial%20manufacturing%20environment%20with%20clean%20organized%20workspace%2C%20high%20contrast%20dramatic%20lighting%20creating%20strong%20shadows%20and%20metallic%20reflections%2C%20professional%20product%20photography%20style%20with%20dark%20background&width=1920&height=1080&seq=hero-bg&orientation=landscape')`
      }}
    >
      {/* Animated particles */}
      <div className="absolute inset-0 overflow-hidden">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute w-2 h-2 bg-orange-400 rounded-full opacity-20 animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${2 + Math.random() * 3}s`
            }}
          />
        ))}
      </div>

      {/* Floating geometric shapes */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-16 h-16 border-2 border-orange-400/30 rotate-45 animate-spin" style={{ animationDuration: '20s' }} />
        <div className="absolute top-40 right-20 w-12 h-12 bg-orange-500/20 rounded-full animate-bounce" style={{ animationDelay: '1s' }} />
        <div className="absolute bottom-40 left-20 w-8 h-8 border-2 border-white/20 animate-pulse" />
        <div className="absolute bottom-20 right-40 w-20 h-20 border border-orange-300/20 rounded-full animate-ping" style={{ animationDuration: '4s' }} />
      </div>

      <div className={`container mx-auto px-4 text-center text-white transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
        <div className="max-w-4xl mx-auto">
          {/* Animated title with changing words */}
          <div className="mb-6">
            <h1 
              className="text-5xl md:text-7xl font-bold tracking-tight"
              style={{ fontFamily: 'Exo 2, sans-serif' }}
            >
              <span className="inline-block transform transition-all duration-500 hover:scale-105">
                {words[currentWord]}
              </span>
              <br />
              <span className="text-orange-400 inline-block transform transition-all duration-500 hover:scale-105" style={{ animationDelay: '0.2s' }}>
                BAĞLANTILAR
              </span>
            </h1>
          </div>

          {/* Animated subtitle */}
          <p className={`text-xl md:text-2xl mb-8 text-gray-300 max-w-2xl mx-auto transition-all duration-1000 delay-300 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'}`}>
            Mühendislik ilkeleriyle üretilen, uzun ömürlü ve güvenilir endüstriyel bağlantı elemanları
          </p>

          {/* Animated button */}
          <div className={`flex justify-center transition-all duration-1000 delay-500 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'}`}>
            <Link to="/urunler">
              <Button 
                size="lg" 
                className="w-full sm:w-auto transform transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-orange-500/25 relative overflow-hidden group"
              >
                <span className="relative z-10">Ürünleri Keşfet</span>
                <div className="absolute inset-0 bg-gradient-to-r from-orange-600 to-orange-400 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
              </Button>
            </Link>
          </div>

          {/* Stats section with animation */}
          <div className={`mt-16 grid grid-cols-1 md:grid-cols-2 gap-8 transition-all duration-1000 delay-700 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'}`}>
            <div className="text-center group cursor-pointer">
              <div className="text-3xl md:text-4xl font-bold text-orange-400 mb-2 transform transition-all duration-300 group-hover:scale-110">
                <span className="counter" data-target="35">35</span>+
              </div>
              <p className="text-gray-300">Yıl Tecrübe</p>
            </div>
            <div className="text-center group cursor-pointer">
              <div className="text-3xl md:text-4xl font-bold text-orange-400 mb-2 transform transition-all duration-300 group-hover:scale-110">
                <span className="counter" data-target="500">500</span>+
              </div>
              <p className="text-gray-300">Mutlu Müşteri</p>
            </div>
          </div>

        </div>
      </div>
      
      {/* Enhanced scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce cursor-pointer group">
        <div className="flex flex-col items-center">
          <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center group-hover:border-orange-400 transition-colors duration-300">
            <div className="w-1 h-3 bg-white/70 rounded-full mt-2 animate-pulse group-hover:bg-orange-400 transition-colors duration-300" />
          </div>
          <i className="ri-arrow-down-line text-white text-xl mt-2 group-hover:text-orange-400 transition-colors duration-300"></i>
        </div>
      </div>

      {/* Gradient overlay for depth */}
      <div className="absolute inset-0 bg-gradient-to-t from-slate-900/20 via-transparent to-transparent pointer-events-none" />
    </section>
  );
}
